import * as React from "react";
import type { SVGProps } from "react";
const SvgAldersgrenser = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 76" {...props}>
    <path
      d="M2308.22 311.149a3.5 3.5 0 0 1-.53.042 3.32 3.32 0 0 1-3.26-2.828c-.62-3.984-2.18-13.775-2.87-17.649v46.921a3.305 3.305 0 1 1-6.61 0v-23.492h-2.84v23.493a3.305 3.305 0 1 1-6.61 0v-46.922c-.69 3.873-2.25 13.665-2.87 17.65a3.308 3.308 0 1 1-6.53-1.054c.27-1.719 2.65-16.867 3.2-19.406 1.38-6.307 6.89-6.307 9.86-6.307h8.75c2.96 0 8.47 0 9.85 6.307.56 2.54 2.93 17.687 3.2 19.406a3.344 3.344 0 0 1-2.74 3.839m-14.69-30.717a7.718 7.718 0 1 1 7.6-7.718 7.66 7.66 0 0 1-7.6 7.718m-19.29 39.819a2 2 0 0 1-.34.028 2.21 2.21 0 0 1-2.16-1.9c-.41-2.68-1.44-9.264-1.89-11.87v31.557a2.186 2.186 0 1 1-4.37 0v-15.8h-1.88v15.8a2.181 2.181 0 1 1-4.36 0v-31.559c-.46 2.605-1.48 9.19-1.9 11.87a2.18 2.18 0 0 1-2.49 1.874 2.253 2.253 0 0 1-1.82-2.582c.18-1.157 1.75-11.345 2.12-13.052.91-4.242 4.55-4.242 6.51-4.242h5.77c1.96 0 5.6 0 6.51 4.242.37 1.708 1.94 11.895 2.12 13.052a2.253 2.253 0 0 1-1.82 2.582m-9.7-20.66a5.193 5.193 0 1 1 5.03-5.19 5.11 5.11 0 0 1-5.03 5.19"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-2253 -265)"
    />
  </svg>
);
export default SvgAldersgrenser;
